import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpFreelancerAreas, HttpFreelancerAreasOptions} from '@features/settings/http/settings.http.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient.ts'

export const useUpdateFreelancerAreas = (
    options?: Omit<UseMutationOptions<unknown, unknown, HttpFreelancerAreasOptions>, 'mutationFn' | 'mutationKey'>
) => {
    const queryClient = useQueryClient()

    return useMutation<unknown, unknown, HttpFreelancerAreasOptions>({
        ...options,
        mutationFn: variables => httpFreelancerAreas(variables),
        onError: errorHandler,
        onSuccess: async (data, variables, context) => {
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.ME]})
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ME]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
